import { Component } from '@angular/core';

@Component({
    selector: 'teller-online-icon-help',
    templateUrl: '../svgs/Help.svg',
    host: {
        class: 'teller-online-icon teller-online-icon--help'
    }
})
export class TellerOnlineIconHelp {
}